import DeleteAsset from "./DeleteAsset";

export default DeleteAsset;
